import LoadingComponent from "./loading.component"

export default LoadingComponent